import React from 'react';
import { Navbar } from './components/sections/Navbar';
import { Hero } from './components/sections/Hero';
import { Training } from './components/sections/Training';
import { Credibility } from './components/sections/Credibility';
import { Pricing } from './components/sections/Pricing';
import { Coaches } from './components/sections/Coaches';
import { LocationCTA } from './components/sections/LocationCTA';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="min-h-screen bg-zinc-950 text-zinc-300 font-sans selection:bg-red-600 selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Training data-id="element-4" />
        <Credibility data-id="element-5" />
        <Pricing data-id="element-6" />
        <Coaches data-id="element-7" />
        <LocationCTA data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}